import { NgModule } from '@angular/core';
import { GridDirective } from '@df/ui/atomic/atom/grid/grid.directive';
import { GridColumnDirective } from '@df/ui/atomic/atom/grid/grid-column.directive';

@NgModule({
    imports: [GridDirective, GridColumnDirective],
    exports: [GridDirective, GridColumnDirective]
})
export class GridModule {}
